export default __webpack_public_path__ + "static/saptaparni-150x119-fbd0078c2a5ae6ca723d5740f0dc82c1.png";